import React, { useState } from 'react';
import useApplePay from '../../../hooks/apple-pay';
import ApiClient from '../../../ApiClient';
import ApplePayLogo from './../../../assets/images/apple_pay.svg';
import PoweredByBox from '../../../common/poweredByBox';
import { DigitalWalletProviders } from '../../../common/constans';

const { applePayMerchantValidation, payV2 } = ApiClient();

const ApplePayForm = ({ payment_session_info, onPaymentChargeSuccessful, onPaymentChargeFailed }) => {
    const isApplePayAvailable = useApplePay();
    const [isDisabled, setIsDisabled] = useState(false);

    const handlePayment = () => {
        setIsDisabled(true)
        const paymentRequest = {
            countryCode: 'EG',
            currencyCode: payment_session_info.currency,
            supportedNetworks: ["visa", "masterCard", "meeza"],
            merchantCapabilities: ["supports3DS", "supportsDebit", "supportsCredit"],
            total: {
                label: payment_session_info.merchant_name,
                amount: payment_session_info.amount_to_pay.toFixed(2)
            },
        };

        const session = new window.ApplePaySession(3, paymentRequest);

        const onMerchantValidationSuccess = (response) => {
            if (Object.hasOwn(response, "succeeded") && response.succeeded && response.session) {
                return session.completeMerchantValidation(response.session);
            }
            alert(response.error_message || "Apple pay merchant validation error")
            session.abort();
        }

        const onMerchantValidationFailure = (error) => {
            alert(error.error_message || "Apple pay merchant validation error")
            session.abort();
        }

        session.onvalidatemerchant = async (event) => {
            const requestDTO = {
                validation_url: event.validationURL,
                display_name: payment_session_info.merchant_name
            }
            await applePayMerchantValidation(requestDTO, payment_session_info.authToken, onMerchantValidationSuccess, onMerchantValidationFailure);
        };

        const onPaymentChargeSuccess = (response) => {
            if (response.succeeded && !response.error_message) {
                session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
                onPaymentChargeSuccessful(response)
            } else {
                session.completePayment(window.ApplePaySession.STATUS_FAILURE);
                onPaymentChargeFailed({message: response.error_message, ...response})
            }
        }

        const onPaymentChargeFail = (error) => {
            session.completePayment(window.ApplePaySession.STATUS_FAILURE);
            onPaymentChargeFailed(error)
        }

        session.onpaymentauthorized = async (event) => {
            try {
                const payload = {
                    session_id: payment_session_info.sessionId,
                    payment_token: JSON.stringify(event.payment.token.paymentData),
                    digital_wallet_provider: DigitalWalletProviders.ApplePay
                }
                await payV2(payload, payment_session_info.authToken, onPaymentChargeSuccess, onPaymentChargeFail);
            } catch (err) {
                console.log("Error Payment", err);
                session.completePayment(window.ApplePaySession.STATUS_FAILURE);
            }
        };

        session.oncancel = event => {
            setIsDisabled(false)
        };

        session.begin();
    };

    if (!isApplePayAvailable) return null;

    return (
        <div className='row'>
            <div className="mt-2">
                <div className="text-center">
                    <div className='my-5'>
                        <img style={{ maxHeight: "100px" }} className='img-fluid' src={ApplePayLogo} alt='Apple Pay' />
                    </div>
                    {
                        <button className="btn btn-md primary-btn pl-4 pr-4"
                            disabled={isDisabled}
                            style={{ width: "50%" }}
                            onClick={handlePayment}>
                            Pay {payment_session_info?.should_show_amount === true && payment_session_info?.amount_to_pay !== null &&
                                `${payment_session_info?.amount_to_pay.toFixed(2)} ${payment_session_info?.currency}`}
                        </button>
                    }
                </div>
                <PoweredByBox />
            </div>
        </div>
    )
};

export default ApplePayForm;